import React from 'react'
import { Grid, Typography, Box } from "@mui/material";
// import {leaderStyles} from "../styles/leader"
import { leaderStyles } from '../../styles/landing';
import {content} from "../../constants"

const Leader = () => {
    const classes = leaderStyles()
  return (
    <>
    <section id ="leader">
    <Grid container justify="center">
    <Grid item sm={12} xs={12} md={12}> 
    <Typography >
      <Box fontFamily="CormorantBoldItalic" style={{color:"rgb(115 74 153)"}} className={classes.heading}>Our Leader</Box></Typography>
    </Grid>
    </Grid>
    <div className={classes.leader}>  
    <Grid container justify="center">
    
      <Grid item sm={12} xs={12} md={6} lg={6} className={classes.imageView}>
        <img src="assets/images/leader.jpg" className={classes.Images} alt="" />
      </Grid>
      <Grid item sm={12} xs={12} md={6} lg={6} className={classes.letsPlanDesc}>
        <Typography component="div">
          <Box
            fontFamily="CormorantBoldItalic"
            className={classes.Heading}
          >
           {/* We make Arborist Reports! */}
          </Box>
          <Box
            fontFamily="GothamBook"
            className={`${classes.Message}`}
            style={{color:"#fff"}}
          >
            {content.leaderIntro1}
          </Box>
          <Box
            fontFamily="GothamBook"
            className={`${classes.Message}`}
            style={{color:"#fff"}}
          >
            {content.leaderIntro2}
            </Box>
        </Typography>
      </Grid>
    </Grid>
     </div> 
     </section> 
     </>
  )
}

export default Leader